(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aqta-header"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.aqta-home__header').forEach((header) => {
      if (header.dataset.aqtaHeaderReady === 'true') return;
      header.dataset.aqtaHeaderReady = 'true';
      const toggle = header.querySelector('.aqta-home__check');
      const drops = Array.from(header.querySelectorAll('[data-aqta-drop]'));
      drops.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          drops.forEach((other) => {
            if (other !== menu) other.open = false;
          });
        });
      });
      const closeOutside = (event) => {
        const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
        const target = event.target;
        drops.forEach((drop) => {
          if (!drop.open) return;
          const inside = path.length ? path.includes(drop) : target instanceof Node && drop.contains(target);
          if (!inside) drop.open = false;
        });
      };
      document.addEventListener('click', closeOutside, true);
      window.addEventListener('blur', () => {
        drops.forEach((drop) => { drop.open = false; });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        drops.forEach((drop) => { drop.open = false; });
      });
      header.querySelectorAll('.aqta-home__nav a').forEach((link) => {
        link.addEventListener('click', () => {
          if (toggle) toggle.checked = false;
        });
      });

      const cartLink = header.querySelector('.aqta-home__cart');
      const cartCount = header.querySelector('[data-aqta-cart-count]');
      const drawer = document.getElementById('cart-drawer');
      if (cartLink && drawer && typeof drawer.showModal === 'function') {
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          if (!drawer.open) drawer.showModal();
        });
      }
      const drawerItems = document.getElementById('cart-drawer-items');
      if (cartCount && drawerItems) {
        let pending;
        const refreshCount = () => {
          clearTimeout(pending);
          pending = setTimeout(() => {
            fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then((response) => response.json())
              .then((cart) => { cartCount.textContent = cart.item_count; })
              .catch(() => {});
          }, 150);
        };
        new MutationObserver(refreshCount).observe(drawerItems, { childList: true, subtree: true });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
